import React from 'react';
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
    position: 'relative',
    zIndex: 1000000,
  },
  loader: {
    background: 'rgba(0,0,0,.5)',
    zIndex: 10000000,
  },
  progress: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '50%',
  },
  loaderText: {
    color: theme.palette.white.main,
    fontSize: 18,
  },
  loaderImg: {
    animation: `$zoom 1000ms ease-in-out infinite`,
  },
  '@keyframes zoom': {
    '0%': {
      transform: 'scale(1)',
    },
    '50%': {
      transform: 'scale(1.2)',
    },
    '100%': {
      transform: 'scale(1)',
    },
  },
}));

function LoadingSpinner(props) {
  // eslint-disable-next-line react/prop-types
  const text = props.text;
  const classes = useStyles();

  return (
    <Box
      height="100dvh"
      width="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      position="fixed"
      className={classes.loader}
    >
      <Box className={classes.root}>
        <Box className={classes.progress}>
          <Box mr={2}>
            <img src="/logo512.png" className={classes.loaderImg} width="50" alt="PrestoBots" />
          </Box>
          <Typography className={classes.loaderText}>{text || 'cargando...'}</Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default LoadingSpinner;
